import {SET_TRANSACTION_PAYMENT_DROPDOWN_VALUE} from "../action";

export function setTransactionPaymentDropdownValue(domainName, domainValue) {
    return (dispatch) => {
        dispatch({type: SET_TRANSACTION_PAYMENT_DROPDOWN_VALUE, payload: {domainName, domainValue}})
    }
}
